import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  InputBase,
  useMediaQuery,
  Popover,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HomeIcon from "@mui/icons-material/Home";
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from "@mui/icons-material/Person";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { setMainSearch } from "../../../redux/publicReducer/actions";

// Styled components using MUI v5 styled API
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  flexGrow: 1,
}));

const MenuButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing ? theme.spacing(2) : '16px',
}));

const Title = styled(Typography)(({ theme }) => ({
  flexGrow: 1,
  [theme.breakpoints.up("sm")]: {
    display: "block",
  },
}));

const Search = styled('div')(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("xs")]: {
    marginLeft: theme.spacing ? theme.spacing(4) : '32px',
    width: "auto",
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing ? theme.spacing(0, 2) : '0 16px',
  height: "100%",
  position: "absolute",
  zIndex: 100,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing ? theme.spacing(1, 1, 1, 0) : '8px 8px 8px 0',
    paddingLeft: theme.spacing ? `calc(1em + ${theme.spacing(6)})` : 'calc(1em + 48px)',
    transition: theme.transitions.create("width"),
    width: "0px",
    [theme.breakpoints.up("xs")]: {
      width: "0ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export function MainNavigation() {
  const { mainSearch, user } = useSelector((state) => state.public);
  const match = useRouteMatch();
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:600px)");
  const dispatch = useDispatch();
  let inputRef = React.useRef(null);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <StyledAppBar
        position="sticky"
        color="inherit"
        style={{ marginBottom: "1rem" }}
        elevation={0}
      >
        <Toolbar>
          <MenuButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleClick}
          >
            <MenuIcon />
          </MenuButton>

          <Title
            variant="h6"
            noWrap
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push(`/home`);
            }}
          >
            AJ's Keto Factory
          </Title>
          <Search>
            <SearchIconWrapper>
              <IconButton
                onClick={() => {
                  //console.log(inputRef.current);
                  inputRef.current?.focus();
                }}
              >
                <SearchIcon fontSize="large" />
              </IconButton>
            </SearchIconWrapper>
            <form
              onSubmit={() => {
                history.push("/");
              }}
            >
              <StyledInputBase
                placeholder="Search…"
                value={mainSearch}
                inputRef={inputRef}
                onChange={(e) => dispatch(setMainSearch(e.target.value))}
                inputProps={{ "aria-label": "search" }}
              />
            </form>
          </Search>
          {user?.userType === "CUSTOMER" && (
            <div>
              <IconButton onClick={() => {}}>
                <ExitToAppIcon />
              </IconButton>
            </div>
          )}
        </Toolbar>
      </StyledAppBar>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div
          style={{
            height: "100vh",
            maxHeight: "100vh",
            position: "fixed",
            left: "0px",
            top: "0px",
            width: isMobile ? "80vw" : "30vw",
            padding: "0rem 2rem",
            backgroundColor: "#005CB8",
          }}
        >
          <IconButton
            onClick={handleClose}
            style={{
              marginBottom: "1rem",
              marginLeft: "-30px",
            }}
          >
            <CloseIcon fontSize="large" style={{ fontSize: "2.5rem" }} />
          </IconButton>

          <List style={{ marginTop: "1rem" }}>
            <ListItem
              style={{
                borderBottom: "1px solid gray",
                borderTop: "1px solid gray",
                width: "90%",
                borderCollapse: "collapse",
              }}
              button
              onClick={() => {
                history.push("/home");
              }}
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>
            {user && user?.userType === "CUSTOMER" && (
              <>
                <ListItem
                  button
                  onClick={() => {}}
                  style={{ borderBottom: "1px solid gray", width: "90%" }}
                >
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText primary="Profile" />
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    history.push("/order-history");
                  }}
                  style={{ borderBottom: "1px solid gray", width: "90%" }}
                >
                  <ListItemIcon>
                    <FastfoodIcon />
                  </ListItemIcon>
                  <ListItemText primary="Your Orders" />
                </ListItem>

                <ListItem
                  button
                  onClick={() => {}}
                  style={{ borderBottom: "1px solid gray", width: "90%" }}
                >
                  <ListItemIcon>
                    <ExitToAppIcon />
                  </ListItemIcon>
                  <ListItemText primary="Sign out" />
                </ListItem>
              </>
            )}
          </List>
        </div>
      </Popover>
    </>
  );
}
